<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">
        If
        <number-value :value="vol1" unit="\text{mL}" />
        of
        <number-value :value="conc1" unit="\text{M}" />
        <chemical-latex content="CuSO4" />
        is placed into a
        <stemble-latex content="$250.00\,\text{mL}$" />
        volumetric flask and water is added to the mark, what is the resulting diluted
        concentration?
      </p>

      <calculation-input
        v-model="inputs.conc2"
        prepend-text="$\ce{[CuSO4]}_\text{dil}:$"
        append-text="$\text{M}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'Question429',
  components: {
    ChemicalLatex,
    StembleLatex,
    CalculationInput,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        conc2: null,
      },
    };
  },
  computed: {
    vol1() {
      return this.taskState.getValueBySymbol('vol1').content;
    },
    conc1() {
      return this.taskState.getValueBySymbol('conc1').content;
    },
  },
};
</script>
